import React from 'react'
import {
  Box,
  Grid,
  RadioGroup,
  FormControl,
  FormHelperText,
  FormControlLabel,
  Radio,
} from '@material-ui/core'
import { Controller, useFormContext } from 'react-hook-form'
import { KeyboardDatePicker } from '@material-ui/pickers'

import { AutocompleteTypeAndSearch, Select } from 'components'
import useStyles from './styles'
import useFetch from 'hooks/useFetch'
import * as service from 'service'
import constants from 'constants/index'

const CookiesConsentsForm = () => {
  const { control, watch, errors, clearError } = useFormContext()
  const reportSelected = watch('reportSelected')
  const classes = useStyles()

  // Buscar lista de banners para o autocomplete
  const { response: bannersResponse } = useFetch(
    service.cookies.banner.get,
    {},
    [],
  )
  const banners = bannersResponse?.data?.banners || []

  return (
    <Grid item xs={12}>
      <FormControl component="fieldset" error={!!errors.reportSelected}>
        <Controller
          name="reportSelected"
          control={control}
          defaultValue=""
          as={
            <RadioGroup>
              <FormControlLabel
                value={constants.cookies.reports.REPORT_TYPES.COMPLETE}
                control={<Radio classes={{ checked: classes.checked }} />}
                className={classes.radioLabel}
                label="Relatório completo (todos os banners no último mês)"
              />
              <FormControlLabel
                value={constants.cookies.reports.REPORT_TYPES.BY_BANNER}
                control={<Radio classes={{ checked: classes.checked }} />}
                className={classes.radioLabel}
                label="Relatório por banner (com filtros)"
              />
            </RadioGroup>
          }
          onChange={([e]) => {
            clearError('reportSelected')
            return e.target.value
          }}
        />
        {!!errors.reportSelected && (
          <FormHelperText error={!!errors.reportSelected}>
            {errors.reportSelected.message}
          </FormHelperText>
        )}
      </FormControl>

      {reportSelected === constants.cookies.reports.REPORT_TYPES.BY_BANNER && (
        <Box mt={3}>
          <form id="cookies-consents-form">
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <AutocompleteTypeAndSearch
                  name="bannerId"
                  requestToLoadOptions={async (term) => {
                    if (!term || term.length < 3) return []
                    return banners.filter((banner) =>
                      banner.name?.toLowerCase().includes(term.toLowerCase()),
                    )
                  }}
                  textField={{
                    label: 'Nome do banner',
                    variant: 'outlined',
                    error: !!errors.bannerId,
                    helperText: errors?.bannerId?.message,
                  }}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <Controller
                  name="consentType"
                  control={control}
                  defaultValue=""
                  as={
                    <Select
                      label="Tipo de consentimento (opcional)"
                      items={constants.cookies.reports.CONSENT_TYPE_OPTIONS}
                      error={!!errors.consentType}
                      helperText={errors?.consentType?.message}
                      fullWidth
                    />
                  }
                  mode="onChange"
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <Controller
                  defaultValue={watch('startDate')}
                  as={
                    <KeyboardDatePicker
                      fullWidth
                      format="DD/MM/yyyy"
                      label="Data inicial (opcional)"
                      error={!!errors.startDate}
                      helperText={errors?.startDate?.message}
                      onChange={(newValue) => ({ value: newValue })}
                    />
                  }
                  control={control}
                  name="startDate"
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <Controller
                  defaultValue={watch('endDate')}
                  as={
                    <KeyboardDatePicker
                      fullWidth
                      format="DD/MM/yyyy"
                      label="Data final (opcional)"
                      error={!!errors.endDate}
                      helperText={errors?.endDate?.message}
                      onChange={(newValue) => ({ value: newValue })}
                    />
                  }
                  control={control}
                  name="endDate"
                />
              </Grid>
            </Grid>
          </form>
        </Box>
      )}
    </Grid>
  )
}

export default CookiesConsentsForm
